import { RefStatutCode } from './enums/ref-statut-code.enum';

export class RefStatut {
    static jsonMap = {
        id: { key: 'id' },
        code: { key: 'code' },
        libelle: { key: 'libelle' }
    };

    public id: number = undefined;
    public code: RefStatutCode = undefined;
    public libelle: string = undefined;
}
